import React from 'react';

import { designTokens, Flex, Typography } from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';

import Warning from '../../resources/Warning.svg';

const {
  colorBackgroundDanger,
  spaceSmall,
  radiusSmall,
  colorTextDanger,
  spaceMedium,
} = designTokens;

const TokenExpired = () => {
  const { t } = useTranslation();

  return (
    <Flex
      css={{
        background: colorBackgroundDanger,
        borderRadius: radiusSmall,
        padding: spaceSmall,
        color: colorTextDanger,
        gap: spaceSmall,
        marginBottom: spaceMedium,
      }}
    >
      <img src={Warning} alt="Warning" />
      <Typography>
        {t('forgotPasswordPage.passwordResetLinkExpired')}
      </Typography>
    </Flex>
  );
};

export default TokenExpired;
